<div class="main-card">
    
    <h5>Mis recompensas</h5>
    <div class="main-rewards">
      <span class="title">Al día de hoy tienes</span>
      <div class="detail">
        <img src="rewards/icon/coin.svg" alt="Rewards" />
        <span class="bold"
          >{{ selectedWalletDetail?.availableBalance ?? 0 }} USD Rewards</span
        >
      </div>
    </div>
    <div class="main-rewards">
      <span class="title">Noches fin de semana</span>
      <div class="detail">
        <img src="rewards/icon/nights.svg" alt="Noches fin de semana" />
        <span>{{ selectedWalletDetail?.weekendBalance ?? 0 }} USD Rewards</span>
      </div>
    </div>
    <div class="main-rewards">
      <span class="title">Noches regulares</span>
      <div class="detail">
        <img src="rewards/icon/nights.svg" alt="Noches regulares" />
        <span
          >{{ selectedWalletDetail?.regularDaysBalance ?? 0 }} USD Rewards</span
        >
      </div>
    </div>

    <div class="level">
      <a href="#">Ver mis histórico de recompensas</a>
    </div>
  </div>
